import React, { FC } from 'react';
import { Stack, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

export const ErrorOverlayDataGrid: FC = () => {
  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        my: 1,
      }}>
      <ErrorOutlineIcon fontSize="small" color="primary" />
      <Typography
        sx={(theme) => ({
          color: theme.palette.primaryBase.main,
        })}
        variant="body2">
        An error occured, data could not be loaded.
      </Typography>
    </Stack>
  );
};
